import React, {
  ReactNode,
} from 'react';

type Props = {
  topBar: ReactNode;
  documentViewer: ReactNode;
  propertiesPanel: ReactNode;
};

export default function BuilderLayout({
  topBar,
  documentViewer,
  propertiesPanel,
}: Props) {
  return (
    <div className="flex h-full min-h-0 w-full flex-col bg-gray-100">
      {topBar}
      <div className="grid min-h-0 flex-1 grid-cols-[minmax(560px,1fr)_320px]">
        <main className="min-h-0 overflow-auto">
          {documentViewer}
        </main>
        <aside className="min-h-0 border-l border-gray-200 bg-white">
          {propertiesPanel}
        </aside>
      </div>
    </div>
  );
}
